import { IntegrationEnum } from 'models/InternalIntegrationSetting';

export const CHANNEL_NAME_LINKS = {
  [IntegrationEnum.AIRBNB]: 'https://www.airbnb.com/',
  [IntegrationEnum.BOOKING_COM]: 'https://www.booking.com/',
  [IntegrationEnum.HVMI]: 'https://homes-and-villas.marriott.com/',
  [IntegrationEnum.HOMEAWAY]: 'https://www.vrbo.com/',
  [IntegrationEnum.TRIPADVISOR]: 'https://www.tripadvisor.com/',
  [IntegrationEnum.EGETINNZ]: 'http://www.egetinnz.com/',
  [IntegrationEnum.GOLIGHTLY]: 'https://www.wegolightly.com/',
  [IntegrationEnum.GETAWAYGOGO]: 'https://www.getawaygogo.com/',
  [IntegrationEnum.VACAYMYWAY]: 'https://vacaymyway.com/',
  [IntegrationEnum.HOMADS]: 'https://homads.com/',
  [IntegrationEnum.WHIMSTAY]: 'https://whimstay.com/',
  [IntegrationEnum.FINDRENTALS]: 'https://www.findrentals.com/',
  [IntegrationEnum.TRAVELSTAYTION]: 'https://www.travelstaytion.com/',
  [IntegrationEnum.OWNERDIRECT]: 'https://www.ownerdirect.com/',
  [IntegrationEnum.B0ARDING]: 'https://b0arding.com/',
  [IntegrationEnum.BNBFINDER]: 'https://www.savvy.com/list',
  [IntegrationEnum.LODGELOVERS]: 'https://lodgelovers.com/',
  [IntegrationEnum.LAKE]: 'https://www.lake.com/',
  [IntegrationEnum.MINISTAYS]:
    'https://ministays.com/version-test/hostfully_authorize',
  [IntegrationEnum.TRAMONA]: 'https://www.tramona.com/',
  [IntegrationEnum.FLATAWAY]: 'https://partners.flataway.com/',
  [IntegrationEnum.STAY]: 'https://staywithstay.com/hosts/how-it-works',
  [IntegrationEnum.NEXTPAX]: 'https://nextpax.com/',
  [IntegrationEnum.REDAWNING]: 'https://www.redawning.com/',
  [IntegrationEnum.RENTALS_UNITED]: 'https://rentalsunited.com/',
  [IntegrationEnum.THE_MONAKER_GROUP]: 'http://monakergroup.com/',
  [IntegrationEnum.BLUEGROUND]:
    'https://partner-network.theblueground.com/?utm_source=pms&utm_medium=website&utm_campaign=hostfully',
  [IntegrationEnum.CREWDOGS]: 'https://www.crewdogs.com/community',
  [IntegrationEnum.STAYNEARN]: 'http://www.staynearn.com/',
  [IntegrationEnum.HOUFY]: 'https://www.houfy.com/',
  [IntegrationEnum.HOMETOGO]: 'https://www.hometogo.com/',
  [IntegrationEnum.ANYSTAY]: 'https://anystay.com.au/',
  [IntegrationEnum.HOLIDU_COM]: 'http://holidu.com/',
  [IntegrationEnum.FOXHOLE]: 'http://stayfoxhole.com/',
};

export const CHANNEL_SIGNUP_LINKS = {
  [IntegrationEnum.TRAVELSTAYTION]:
    'https://account.travelstaytion.com/signup?',
  [IntegrationEnum.HVMI]: 'https://hvmi.tfaforms.net/91',
};
